import { computed, makeObservable } from 'mobx'

import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

import {
  PERMISSION_GROUP_KIND_ADMIN,
  PERMISSION_GROUP_KIND_DEFAULT,
  PERMISSION_GROUP_KIND_ONBOARDING,
} from 'modules/permissions/lib/constants'
import permissionAccessGroups from 'modules/permissions/store/collections/permissionAccessGroups'
import type PermissionAccessGroup from 'modules/permissions/store/models/PermissionAccessGroup'

export interface IPermissionGroup {
  id: number
  company_id: number
  default_group: boolean
  legacy_admin: boolean
  name: string
  kind: 'admin' | 'custom' | 'default' | 'onboarding'
}

class PermissionGroup extends Model<IPermissionGroup> {
  constructor(attr: IPermissionGroup) {
    super(attr)
    makeObservable(this, {
      permissionAccessGroups: computed,
      title: computed,
    })
  }

  static urlRoot() {
    return '/permissions/permission_groups'
  }

  get permissionAccessGroups(): PermissionAccessGroup[] {
    return permissionAccessGroups.filter(
      (group) => group.attributes.permissions_group_id === this.attributes.id
    )
  }

  get title(): string {
    if (this.attributes.kind === PERMISSION_GROUP_KIND_ONBOARDING) {
      return i18n.t('settings.permissions.onboarding')
    }

    if (this.attributes.kind === PERMISSION_GROUP_KIND_ADMIN || this.attributes.legacy_admin) {
      return i18n.t('settings.permissions.legacy_admin')
    }

    if (this.attributes.kind === PERMISSION_GROUP_KIND_DEFAULT || this.attributes.default_group) {
      return i18n.t('settings.permissions.default_group')
    }

    return this.attributes.name
  }

  get isDefaultGroup(): boolean {
    return this.attributes.kind === PERMISSION_GROUP_KIND_DEFAULT || this.attributes.default_group
  }
}

export default PermissionGroup
